import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

interface VideoLinkPreviewProps {
  value: string;
  onChange: (val: string) => void;
}

function getEmbedUrl(url: string): string | null {
  // YouTube
  const yt = url.match(/(?:youtu.be\/|youtube.com\/(?:watch\?v=|embed\/))([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  // Vimeo
  const vimeo = url.match(/vimeo.com\/(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  // Direct video file
  if (url.match(/\.(mp4|webm|ogg)$/i)) return url;
  return null;
}

const VIDEO_SYSTEM_URL = 'https://videos.example.com';

const VideoLinkPreview: React.FC<VideoLinkPreviewProps> = ({ value, onChange }) => {
  const embedUrl = getEmbedUrl(value);
  return (
    <FormControl variant="outlined" sx={{ mt: 0 }}>
      <Box sx={{
        position: 'relative',
        border: '1.5px solid #bdbdbd',
        borderRadius: 2,
        p: 2,
        pt: 3,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}>
        <FormLabel
          component="legend"
          sx={{
            position: 'absolute',
            top: 0,
            left: 12,
            transform: 'translateY(-50%)',
            bgcolor: '#ffffff',
            px: 0.5,
            fontSize: 13,
            color: 'text.secondary',
            zIndex: 1,
          }}
        >
          Video
        </FormLabel>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <TextField
            label="Video Link"
            value={value}
            onChange={e => onChange(e.target.value)}
            fullWidth
          />
          <Box sx={{ ml: 2, minWidth: 120, textAlign: 'right' }}>
            <Link href={VIDEO_SYSTEM_URL} target="_blank" rel="noopener">
              Go to Video System
            </Link>
          </Box>
        </Box>
        <Box sx={{ mt: 1, width: 350, minHeight: 180, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fafafa', border: '1px solid #e0e0e0', borderRadius: 2 }}>
          {embedUrl ? (
            embedUrl.endsWith('.mp4') || embedUrl.endsWith('.webm') || embedUrl.endsWith('.ogg') ? (
              <video src={embedUrl} controls style={{ maxWidth: '100%', maxHeight: 320 }} />
            ) : (
              <iframe
                src={embedUrl}
                title="Video Preview"
                width="100%"
                height="180"
                frameBorder={0}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            )
          ) : (
            <Box sx={{ color: '#bdbdbd', fontSize: 18, textAlign: 'center' }}>
              Video preview will appear here
            </Box>
          )}
        </Box>
      </Box>
    </FormControl>
  );
};

export default VideoLinkPreview;
